const Chip = ({
  text,
  type,
  setType,
}: {
  text: string;
  type: string;
  setType: any;
}) => {
  const activeClass =
    type === text
      ? "bg-[#007aff] text-white"
      : "bg-white md:bg-transparent border border-[#d7d7d7]";
  return (
    <>
      <button
        type="button"
        className={
          "h-6 py-1 md:h-9 px-4 md:py-[7px] text-xs md:text-[17px] capitalize rounded-[30px] md:rounded-[40px] justify-center items-center gap-1 inline-flex " +
          activeClass
        }
        onClick={() => {
          setType(text);
        }}
      >
        {text}
      </button>
    </>
  );
};
export default Chip;
